import { mockReferralDB } from './mockDb';
import type { ReferralPolicy } from '../types';

export const policyService = {
  async get(): Promise<ReferralPolicy | null> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getPolicy() || null;
  },

  async update(data: Partial<Omit<ReferralPolicy, 'id' | 'createdAt'>>): Promise<ReferralPolicy> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updatePolicy(data);
    if (!updated) throw new Error('Policy not found');
    return updated;
  },
};
